<template>
  <div class="mql-datefilter">
    <mql-textradio-group v-model="textValue" @change="textValueChange">
      <mql-textradio :label="0">昨天</mql-textradio>
      <mql-textradio :label="1">今天</mql-textradio>
      <mql-textradio :label="2">本月</mql-textradio>
      <mql-textradio :label="3">上个月</mql-textradio>
    </mql-textradio-group>
    <el-date-picker class='picker' v-model="startDate" :type="type" :editable="false" placeholder="选择日期" :format="format" :value-format="valueFormat" :picker-options="pickerOptions" default-time="00:00:00" @change="changeEnd"></el-date-picker>
    <span class="text-split">至</span>
    <el-date-picker class='picker' :editable="false" v-model="endDate" :type="type" placeholder="选择日期" :format="format" :value-format="valueFormat" default-time="23:59:00" @change="changeStart"></el-date-picker>
  </div>
</template>

<script>
import { DatePicker, TimeSelect, TimePicker } from "element-ui";
import { mapState } from "vuex";
export default {
  name: "MqlDatefilter",
  components: {
    elDatePicker: DatePicker,
    elTimeSelect: TimeSelect,
    elTimePicker: TimePicker,
  },
  props: {
    type: {
      type: String,
      default: "datetime",
      validator: function(value) {
        return ["datetime", "date"].indexOf(value) !== -1;
      },
    },
    // 如果是跟进记录筛选时间 那么就是两年的记录
    flagTime: {
      type: Boolean,
      default: false,
    },
    // 设置输入框显示格式
    format: {
      type: String,
      default: function() {
        return this.type === "datetime" ? "yyyy-MM-dd HH:mm:ss" : "yyyy-MM-dd";
      },
    },
    valueFormat: {
      type: String,
      default: "timestamp",
    },
  },
  computed: {
    ...mapState(["serverTime"]),
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: null,
      },
      currentValue: this.value === undefined || this.value === null ? [] : this.value,
      textValue: 1,
      pickerOptionsStart: {},
      pickerOptionsEnd: {},
      startDate: null,
      endDate: null,
      inputFormat: this.valueFormat,
      localServerTime: null,
    };
  },
  watch: {
    currentValue: {
      handler(val) {
        this.$emit("change", val);
        this.$emit("input", val);
      },
      deep: true,
    },
  },
  created() {
    // @ts-ignore
    this.localServerTime = this.serverTime || JSON.parse(localStorage.getItem("serverTime"));

    this.startDate = this.$moment(this.localServerTime.date.split(" ")[0])
      .startOf("day")
      .valueOf();
    this.endDate = this.$moment(this.localServerTime.date.split(" ")[0]).valueOf();
    this.pickerOptions.disabledDate = (time) => {
      let curDate = new Date(this.localServerTime.date.split(" ")[0]).toString();
      let curDateYear = new Date(this.localServerTime.date.split(" ")[0]).getFullYear();
      let curYearOneDate = curDate.replace(curDateYear, curDateYear - 2);
      let oneYear = new Date(curYearOneDate).getTime();
      return time.getTime() < oneYear;
    };

    // 判断是否有缓存
    const conditionalData = JSON.parse(window.sessionStorage.getItem("conditionalData"));
    if (conditionalData) {
      const { filteredSubscript, dateRange } = conditionalData;
      this.$nextTick(() => {
        this.textValue = filteredSubscript;
        this.startDate = dateRange[0];
        this.endDate = dateRange[1];
      });
    }
  },
  mounted() {
    // vlaueFormat 日期格式    判断值的格式
    if (this.valueFormat !== "timestamp") {
      // inputFormat 日期格式
      this.inputFormat = this.valueFormat.replace(/yyyy|dd/g, (word) => word.toUpperCase());
    }
  },
  methods: {
    textValueChange() {
      const textValue = this.textValue;
      // const endDate = this.$moment(this.localServerTime.date.split(' ')[0]);
      // valueOf用于返回原始值
      // console.log(
      //   this.$moment(this.localServerTime.date.split(' ')[0])
      //     .startOf("day")
      //     .valueOf()
      // );
      // 更新父组件下标
      this.$emit("upFilteredSubscript", textValue);

      let startDate = "";
      let endDate = "";

      switch (textValue) {
        case 0:
          startDate = this.$moment(this.localServerTime.date.split(" ")[0])
            .subtract(1, "days")
            .startOf("day");
          endDate = this.$moment(this.localServerTime.date.split(" ")[0])
            .subtract(1, "days")
            .startOf("day");
          break;
        case 1:
          startDate = this.$moment(this.localServerTime.date.split(" ")[0]).startOf("day");
          endDate = this.$moment(this.localServerTime.date.split(" ")[0]).startOf("day");
          break;
        case 2:
          startDate = this.$moment(this.localServerTime.date.split(" ")[0]).startOf("month");
          endDate = this.$moment(this.localServerTime.date.split(" ")[0]).startOf("day");
          break;
        case 3:
          startDate = this.$moment(this.localServerTime.date.split(" ")[0])
            .subtract(1, "month")
            .startOf("month");
          endDate = this.$moment(startDate)
            .subtract("month")
            .endOf("month");
          break;
        // case 4:
        //   startDate = this.$moment(this.localServerTime.date.split(' ')[0]).startOf("month");
        //   endDate = this.$moment(this.localServerTime.date.split(' ')[0]).startOf("day");
        //   break;
      }

      this.startDate = this.valueFormat === "timestamp" ? startDate.valueOf() : startDate.format(this.inputFormat);
      this.endDate = this.valueFormat === "timestamp" ? endDate.valueOf() : endDate.format(this.inputFormat);
      this.updateValue();
    },
    /**
     * 更新结束日期后触发
     */
    changeStart() {
      // let year = 31536000000
      let year = 31536000000;
      let date = this.endDate - this.startDate;
      if (this.flagTime) year *= 2;
      if (date > year) {
        console.log(this.flagTime);
        if (this.flagTime) {
          this.$message.warning("所选时间跨度不能超过两年");
          return;
        } else {
          this.$message.warning("所选时间跨度不能超过一年");
          return;
        }
      }
      if (this.startDate && this.endDate) {
        if (this.endDate < this.startDate) {
          this.startDate = this.endDate;
        }
        this.updateTextValue();
      }

      this.pickerOptionsStart = Object.assign({}, this.pickerOptionsStart, {
        disabledDate: (time) => {
          return this.endDate && time.getTime() > this.endDate;
        },
      });

      // 日期筛选器都为空后按 textValue的值去发送请求
      if (this.endDate === null && this.startDate === null) {
        this.textValueChange(); // 获取筛选的时间
        return;
      }

      // console.log("日期更新结束",this.endDate, this.startDate)
      if (!this.endDate && this.startDate) return;
      this.updateValue();
    },
    /**
     * 更新开始日期后触发
     */
    changeEnd() {
      let year = 31536000000;
      let date = this.endDate - this.startDate;
      if (this.flagTime) year *= 2;
      if (date > year) {
        if (this.flagTime) {
          this.$message.warning("所选时间跨度不能超过两年");
          return;
        } else {
          this.$message.warning("所选时间跨度不能超过一年");
          return;
        }
      }

      if (this.startDate && this.endDate) {
        if (this.endDate < this.startDate) {
          this.endDate = this.startDate;
        }
        this.updateTextValue();
      }

      this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
        disabledDate: (time) => {
          return this.startDate && time.getTime() < this.startDate;
        },
      });
      // 日期筛选器都为空后按 textValue的值去发送请求
      if (this.endDate === null && this.startDate === null) {
        this.textValueChange(); // 获取筛选的时间
        return;
      }
      // 如果 this.startDate没有值的话 则不发送请求信息
      if (!this.endDate && this.startDate) return;

      // 发送请求必须满足 this.endData 和 this.startDate 都有值
      this.updateValue();
    },
    /**
     * 更新文本单选值
     */
    updateTextValue() {
      const endDate = this.$moment(this.localServerTime.date.split(" ")[0]).valueOf();

      if (endDate === this.endDate) {
        if (
          this.startDate ===
          this.$moment(this.localServerTime.date.split(" ")[0])
            .startOf("day")
            .valueOf()
        ) {
          this.textValue = 1;
        } else if (
          this.startDate ===
          this.$moment(this.localServerTime.date.split(" ")[0])
            .subtract(2, "days")
            .startOf("day")
            .valueOf()
        ) {
          this.textValue = 2;
        } else if (
          this.startDate ===
          this.$moment(this.localServerTime.date.split(" ")[0])
            .subtract(6, "days")
            .startOf("day")
            .valueOf()
        ) {
          this.textValue = 3;
        } else if (
          this.startDate ===
          this.$moment(this.localServerTime.date.split(" ")[0])
            .startOf("month")
            .valueOf()
        ) {
          this.textValue = 4;
        }
      }
    },
    /**
     * 更新当前选择时间
     */
    updateValue() {
      if (this.endDate && this.type === "date") {
        if (this.valueFormat === "timestamp") {
          this.endDate = this.$moment(this.endDate)
            .endOf("day")
            .valueOf();
        } else {
          this.endDate = this.$moment(this.endDate, this.inputFormat)
            .endOf("day")
            .format(this.inputFormat);
        }
      }

      // 设置吗默认时间厝
      this.currentValue = [this.startDate || new Date(new Date(new Date(this.localServerTime.date.split(" ")[0]).toLocaleDateString()).getTime()), this.endDate || this.$moment(this.localServerTime.date.split(" ")[0]).valueOf()];

      console.log(this.currentValue);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-input .el-input__inner {
  padding: 0 5px;
}
.picker {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.mql-datefilter {
  /deep/ .el-input {
    width: 150px;
  }
  .fc-4 {
    color: #a1a1a1;
    font-size: 16px;
  }
}
/deep/.el-input .el-input__inner {
  padding-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/core/MqlDatefilter/index.vue